<template>
  <article class="menuInter">
    <!-- Header -->
    <div class="panel-header">
      <div class="header-content">
        <h2 class="panel-title">Interpretación</h2>
        <div class="breadcrumb" v-if="data.title">
          <span class="breadcrumb-item">{{ data.title }}</span>
        </div>
      </div>
      <button class="nav-button" aria-label="Cerrar" v-on:click="close">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Content -->
    <div class="panel-content">
      <!-- Priority hero -->
      <div class="hero" v-if="data.title">
        <div class="hero-title" :class="titleBg">{{ data.title }}</div>
        <span
          class="hero-tag"
          :class="titleBg"
          v-if="titleBg !== 'bg-sinrango'"
        >
          Prioridad {{ titleBg.split("-")[1] }}
          <template v-if="porcentageG"> · {{ porcentageG }}%</template>
        </span>
        <div class="hero-graph" v-if="graph">
          <y-graph
            :datagraph="graph"
            :cambio="cambio"
            style="height: 65px !important;"
          ></y-graph>
        </div>
      </div>

      <!-- Info -->
      <div class="sections" v-if="data.group">
        <!-- Definition -->
        <div
          class="info-card"
          v-if="
            interpretations[data.group] && interpretations[data.group]['def']
          "
        >
          <button class="info-card-header" v-on:click="switchElement('def')">
            <span class="info-icon"><i class="material-icons">book</i></span>
            <span class="info-card-title">Definición</span>
            <i class="material-icons chevron">{{
              elements.def ? "expand_less" : "expand_more"
            }}</i>
          </button>
          <transition name="fade">
            <div class="info-card-body" v-if="elements.def">
              <p class="info-text">{{ interpretations[data.group]["def"] }}</p>
            </div>
          </transition>
        </div>

        <!-- Priorization -->
        <div
          class="info-card"
          v-if="
            titleBg !== 'bg-sinrango' &&
              interpretations[data.group] &&
              interpretations[data.group]['prt'][titleBg.split('-')[1]]
          "
        >
          <button class="info-card-header" v-on:click="switchElement('prt')">
            <span class="info-icon">
              <i class="material-icons">format_list_numbered</i>
            </span>
            <span class="info-card-title is-capitalized">
              Prioridad - {{ titleBg.split("-")[1] }}
            </span>
            <i class="material-icons chevron">{{
              elements.prt ? "expand_less" : "expand_more"
            }}</i>
          </button>
          <transition name="fade">
            <div class="info-card-body" v-if="elements.prt">
              <div class="info-label">
                <i class="material-icons">lightbulb_outline</i>
                <span>Interpretación</span>
              </div>
              <p class="info-text">
                {{
                  interpretations[data.group]["prt"][titleBg.split("-")[1]]["i"]
                }}
              </p>
              <div class="info-label">
                <i class="material-icons">flag</i>
                <span>Meta</span>
              </div>
              <p class="info-text">
                {{
                  titleBg.split("-")[1] === "alta"
                    ? getMeta(
                        interpretations[data.group]["prt"][
                          titleBg.split("-")[1]
                        ]["m"]
                      )
                    : interpretations[data.group]["prt"][titleBg.split("-")[1]][
                        "m"
                      ]
                }}
              </p>
            </div>
          </transition>
        </div>

        <!-- Risk -->
        <div
          class="info-card"
          v-if="interpretations[data.group] && interpretations[data.group]['r']"
        >
          <button class="info-card-header" v-on:click="switchElement('r')">
            <span class="info-icon">
              <i class="material-icons">error_outline</i>
            </span>
            <span class="info-card-title">¿Cuándo es un riesgo?</span>
            <i class="material-icons chevron">{{
              elements.r ? "expand_less" : "expand_more"
            }}</i>
          </button>
          <transition name="fade">
            <div class="info-card-body" v-if="elements.r">
              <ul class="info-list">
                <li
                  v-for="(r, k) in deleteEmptyElements(
                    interpretations[data.group]['r'].split('-')
                  )"
                  :key="k"
                >
                  {{ r }}
                </li>
              </ul>
            </div>
          </transition>
        </div>

        <!-- Practices -->
        <div
          class="info-card"
          v-if="interpretations[data.group] && interpretations[data.group]['p']"
        >
          <button class="info-card-header" v-on:click="switchElement('p')">
            <span class="info-icon">
              <i class="material-icons">emoji_events</i>
            </span>
            <span class="info-card-title">Prácticas Exitosas</span>
            <i class="material-icons chevron">{{
              elements.p ? "expand_less" : "expand_more"
            }}</i>
          </button>
          <transition name="fade">
            <div class="info-card-body" v-if="elements.p">
              <ul class="info-list">
                <li
                  v-for="(p, k) in deleteEmptyElements(
                    interpretations[data.group]['p'].split('-')
                  )"
                  :key="k"
                >
                  {{ p }}
                </li>
              </ul>
            </div>
          </transition>
        </div>

        <!-- Acciones R -->
        <div
          class="info-card"
          v-if="
            interpretations[data.group] &&
              interpretations[data.group]['accionesRMM']
          "
        >
          <button
            class="info-card-header"
            v-on:click="switchElement('accionesRMM')"
          >
            <span class="info-icon">
              <i class="material-icons">import_contacts</i>
            </span>
            <span class="info-card-title">
              Acciones recomendadas en los manuales del Ministerio
            </span>
            <i class="material-icons chevron">{{
              elements.accionesRMM ? "expand_less" : "expand_more"
            }}</i>
          </button>
          <transition name="fade">
            <div class="info-card-body" v-if="elements.accionesRMM">
              <ul class="info-list">
                <li
                  v-for="(a, k) in deleteEmptyElements(
                    interpretations[data.group]['accionesRMM'].split('-')
                  )"
                  :key="k"
                >
                  {{ a }}
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import yGraph from "../../dashboard/GraphFrs.vue";
import json from "../interpretaciones.json";

export default {
  components: {
    yGraph,
  },
  data() {
    return {
      cambio: 1,
      graph: null,
      titleBg: "bg-sinrango",
      porcentageG: 0,
      interpretations: json,
      elements: {
        def: true,
        prt: true,
        r: true,
        p: true,
        accionesRMM: true,
      },
    };
  },
  methods: {
    createDataGraphHorizontalBar() {
      const data = this.data.data;
      const label = this.data.title;

      if (data && label) {
        const dataHorizontalBar = {
          type: "horizontalBar",
          options: {
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              },
            },
            hover: {
              animationDuration: 0,
            },
            tooltips: {
              enabled: false,
              custom: function(tooltipModel) {
                // Tooltip Element
                let tooltipEl = document.getElementById("chartjs-tooltip");

                // Create element on first render
                if (!tooltipEl) {
                  tooltipEl = document.createElement("div");
                  tooltipEl.id = "chartjs-tooltip";
                  tooltipEl.innerHTML = "<table></table>";
                  tooltipEl.style.backgroundColor = "rgba(0,0,0,0.71)";
                  tooltipEl.style.borderRadius = "5%";
                  document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }

                // Set caret Position
                tooltipEl.classList.remove("above", "below", "no-transform");
                if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                  tooltipEl.classList.add("no-transform");
                }

                function getBody(bodyItem) {
                  return bodyItem.lines;
                }

                // Set Text
                if (tooltipModel.body) {
                  let titleLines = tooltipModel.title || [];
                  let bodyLines = tooltipModel.body.map(getBody);

                  let innerHtml = "<thead>";

                  titleLines.forEach(function(title) {
                    innerHtml +=
                      '<tr><th style="color: white;">' + title + "</th></tr>";
                  });
                  innerHtml += "</thead><tbody>";

                  bodyLines.forEach(function(body, i) {
                    let colors = tooltipModel.labelColors[i];
                    let style = "background:" + colors.backgroundColor;
                    style += "; border-color:" + colors.borderColor;
                    style += "; border-width: 2px";
                    let span = '<span style="' + style + '"></span>';
                    innerHtml +=
                      '<tr><td style="color: white;">' +
                      span +
                      body +
                      "%" +
                      "</td></tr>";
                  });
                  innerHtml += "</tbody>";

                  let tableRoot = tooltipEl.querySelector("table");
                  tableRoot.innerHTML = innerHtml;
                }

                // `this` will be the overall tooltip
                let position = this._chart.canvas.getBoundingClientRect();

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left =
                  position.left +
                  window.pageXOffset +
                  tooltipModel.caretX +
                  "px";
                tooltipEl.style.top =
                  position.top +
                  window.pageYOffset +
                  tooltipModel.caretY +
                  "px";
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding =
                  tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
                tooltipEl.style.pointerEvents = "none";
              },
            },
            scales: {
              xAxes: [
                {
                  ticks: {
                    display: false,
                    beginAtZero: true,
                    max: 100,
                  },
                  scaleLabel: {
                    display: false,
                  },
                  gridLines: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
            },
            legend: {
              position: "top",
              display: false,
            },
            animate: {},
            pointLabelFontFamily: "Quadon Extra Bold",
            scaleFontFamily: "Quadon Extra Bold",
            responsive: true,
            resizeDelay: 0,
            plugins: {
              datalabels: {
                formatter: function(value, context) {
                  if (value >= 3) return `${value}%`;
                  return "";
                },
                textAlign: "start",
              },
            },
          },
          data: {
            labels: ["Data 1"],
            datasets: [
              {
                label: "Dataset 1",
                data: [28],
                backgroundColor: ["#f4cdcd"],
              },
              {
                label: "Dataset 2",
                data: [45.7],
                backgroundColor: ["#facca5"],
              },
              {
                label: "Dataset 3",
                data: [65.9],
                backgroundColor: ["#fff2cc"],
              },
              {
                label: "Dataset 4",
                data: [72.4],
                backgroundColor: ["#d9ead3"],
              },
              {
                label: "Dataset 5",
                data: [32],
                backgroundColor: ["#c8d9f7"],
              },
            ],
          },
        };

        const sumData = data
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        let datasets = [];
        // Función que ordena la data a un formato fijo
        const orderData = (p, d) => {
          const postion = (df) => {
            datasets[df] = d;
          };

          switch (p) {
            case "Riesgo muy alto":
              postion(0);
              break;
            case "Riesgo alto":
              postion(1);
              break;
            case "Riesgo medio":
              postion(2);
              break;
            case "Riesgo bajo":
              postion(3);
              break;
            case "Sin riesgo o riesgo despreciable":
              postion(4);
              break;
            case "Sin riesgo o riesgo bajo":
              postion(5);
              break;
            case "Muy alto":
              postion(0);
              break;
            case "Alto":
              postion(1);
              break;
            case "Medio":
              postion(2);
              break;
            case "Bajo":
              postion(3);
              break;
            case "Muy bajo":
              postion(4);
              break;
            default:
              datasets.push(d);
              break;
          }
          /*
            *
            * case 'Insatifacción muy alta':
                postion(0)
                break;
              case 'Insatifacción alta':
                postion(1)
                break;
              case 'Satifacción muy alta':
                postion(2)
                break;
              case 'Satifacción alta':
                postion(3)
                break;
              case 'Satifacción baja':
                postion(4)
                break;
            * */
        };

        data
          .filter((x) => x.SubGrupo)
          .map((x) => {
            const d = {
              label: "Dataset",
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1,
            };
            const porcentage = this.calculatePorcentage(
              x["countData"]["sum"],
              sumData
            );
            const rango = this.rangoFp(x.SubGrupo);
            d.data.push(porcentage);
            d.label = x.SubGrupo;
            d.backgroundColor.push(rango.color);
            d.borderColor.push(rango.border);

            orderData(d.label, d);
          });

        dataHorizontalBar.data.labels = [label];
        dataHorizontalBar.data.datasets = datasets.filter((x) => {
          if (x) return true;
        });

        this.graph = dataHorizontalBar;
        this.cambio++;
      }
    },
    rangoIntervencion() {
      const p = this.data.data;
      const type = this.data.data[0].Grupo === "RGO-09-Engagement" ? 1 : 0;
      if (p) {
        let result = "";
        // Se suma todos los valores
        const sum = p
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        // Objecto con estructura organizada
        let porcentageGroups = null;

        if (type === 0) {
          porcentageGroups = {
            alta1: {
              groups: ["Riesgo alto", "Riesgo muy alto", "Muy alto", "Alto"],
              sum: 0,
            },
            media: {
              groups: [
                "Riesgo medio",
                "Riesgo alto",
                "Riesgo muy alto",
                "Alto",
                "Muy Alto",
                "Medio",
              ],
              sum: 0,
            },
            destacado: {
              groups: [
                "Sin riesgo o riesgo despreciable",
                "Riesgo bajo",
                "Sin riesgo o riesgo bajo",
                "Factor protector",
                "Bajo",
                "Muy bajo",
              ],
              sum: 0,
            },
          };
        } else if (type === 1) {
          porcentageGroups = {
            alta1: {
              groups: ["Bajo", "Muy bajo"],
              sum: 0,
            },
            media: {
              groups: ["Bajo", "Muy bajo", "Medio"],
              sum: 0,
            },
            destacado: {
              groups: ["Muy alto", "Alto"],
              sum: 0,
            },
          };
        }

        // Se saca la suma para la estrucutura solicitada
        p.map((e) => {
          const sub = !e.SubGrupo ? "" : String(e.SubGrupo);

          if (porcentageGroups.alta1["groups"].includes(sub)) {
            porcentageGroups.alta1.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.media["groups"].includes(sub)) {
            porcentageGroups.media.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.destacado["groups"].includes(sub)) {
            porcentageGroups.destacado.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
        });

        // Se calcula el porcentage para cada elemento del objeto anterior y retornar un rango
        for (const k in porcentageGroups) {
          const porcentage = porcentageGroups[k]["sum"].toFixed(2);

          if (k === "alta1" && porcentage >= 30.0) {
            this.porcentageG = porcentage;
            result = "bg-alta";
            break;
          } else if (k === "media" && porcentage >= 40.0) {
            this.porcentageG = porcentage;
            result = "bg-media";
            break;
          } else if (k === "destacado" && porcentage >= 60.0) {
            this.porcentageG = porcentage;
            result = "bg-destacado";
            break;
          } else if (porcentage < 30.0) {
            this.porcentageG = porcentage;
            result = "bg-sinrango";
          }
        }
        this.titleBg = result;
      }
    },
    rangoFp(p) {
      const rangos = {
        rango0: [
          "Riesgo muy alto",
          "Insatisfacción muy alta",
          "Presentación muy alta de sintomas",
          "Muy alto",
        ], // muy alta
        rango1: [
          "Riesgo alto",
          "Insatisfacción alta",
          "Presentación alta de sintomas",
          "Alto",
        ], // alta
        rango2: [
          "Riesgo medio",
          "Satisfacción muy alta",
          "Presentación media de sintomas",
          "Medio",
        ], // medio
        rango3: [
          "Riesgo bajo",
          "Satisfacción alta",
          "Presentación baja de sintomas",
          "Bajo",
        ], // bajo
        rango4: [
          "Sin riesgo o riesgo despreciable",
          "Sin riesgo o riesgo bajo",
          "Satisfacción baja",
          "Presentación muy baja de sintomas o sin presencia de ellos",
          "Muy bajo",
        ], // sin riesgo o muy bajo
      };
      if (rangos.rango0.includes(p)) {
        return {
          color: "#f4cdcd",
          border: "#f6adad",
        };
      } else if (rangos.rango1.includes(p)) {
        return {
          color: "#facca5",
          border: "#f6b884",
        };
      } else if (rangos.rango2.includes(p)) {
        return {
          color: "#fff2cc",
          border: "#f6db8a",
        };
      } else if (rangos.rango3.includes(p)) {
        return {
          color: "#d9ead3",
          border: "#c3eab5",
        };
      } else if (rangos.rango4.includes(p)) {
        return {
          color: "#c8d9f7",
          border: "#a8c2ef",
        };
      } else {
        return {
          color: "#e1e1e1",
          border: "#c2c0c0",
        };
      }
    },
    calculatePorcentage(v, sum) {
      return ((v * 100) / sum).toFixed(1);
    },
    getMeta(meta) {
      const metas = meta.split(".");
      const porcentage = parseFloat(this.porcentageG).toFixed(0);

      if (porcentage >= 30 && this.porcentageG <= 35) {
        meta = metas[0];
      } else if (porcentage >= 36 && this.porcentageG <= 50) {
        meta = metas[1];
      } else if (porcentage >= 51 && this.porcentageG <= 100) {
        meta = metas[2];
      }

      return meta + ".";
    },
    switchElement(ele) {
      this.elements[ele] = !this.elements[ele];
    },
    deleteEmptyElements(array) {
      return array.filter(function(el) {
        return !!el.length;
      });
    },
    close() {
      this.$emit("closeMenuInter");
    },
  },
  props: {
    data: Object,
  },
  created() {
    if (this.data) {
      this.createDataGraphHorizontalBar();
      this.rangoIntervencion();
    }
  },
  watch: {
    data(nv, ov) {
      this.createDataGraphHorizontalBar();
      this.rangoIntervencion();
    },
  },
};
</script>
<style lang="scss" scoped>
/* Minimal lateral panel — styled after the clima MenuInterpretations panel:
   clean white surface, rounded cards, subtle gray borders, a purple accent
   and justified body text. */
.menuInter {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 32%;
  min-width: 380px;
  max-width: 460px;
  background: #ffffff;
  border-left: 1px solid #e5e7eb;
  box-shadow: -6px 0 24px rgba(0, 0, 0, 0.06);
  z-index: 251;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }
}

/* Header */
.panel-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 16px;
  background: #fafafa;
  border-bottom: 1px solid #f3f4f6;
}

.header-content {
  flex: 1;
  min-width: 0;
}

.panel-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.2;
  color: #111827;
}

.breadcrumb {
  margin-top: 4px;
}

.breadcrumb-item {
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  text-transform: capitalize;
}

.nav-button {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
    color: #374151;
  }
}

/* Content */
.panel-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f9fafb;
  }
  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
  }
}

/* Hero (selected group + range + graph) */
.hero {
  margin-bottom: 20px;
}

.hero-title {
  padding: 14px 16px;
  border-radius: 12px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  text-transform: capitalize;
  color: rgba(58, 58, 58, 0.92);
}

.hero-tag {
  display: inline-flex;
  align-items: center;
  margin-top: 10px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
  color: rgba(58, 58, 58, 0.9);
}

.hero-graph {
  width: 100%;
  margin-top: 14px;
}

/* Accordion cards */
.sections {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-card {
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.info-card-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: none;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
  transition: background 0.2s ease;

  &:hover {
    background: #f9fafb;
  }
}

.info-icon {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f3f0f9;
  color: #522687;

  .material-icons {
    font-size: 19px;
  }
}

.info-card-title {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
  color: #111827;
}

.chevron {
  flex-shrink: 0;
  color: #9ca3af;
  font-size: 22px;
}

.info-card-body {
  padding: 0 16px 16px;
}

.info-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 14px 0 6px;

  &:first-child {
    margin-top: 4px;
  }

  i {
    font-size: 16px;
    color: #522687;
  }
  span {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
  }
}

.info-text {
  margin: 0;
  text-align: justify;
  font-size: 14px;
  line-height: 1.55;
  color: #374151;
}

.info-list {
  margin: 4px 0 0;
  padding-left: 1.2em;
  list-style: disc;

  li {
    font-size: 14px;
    line-height: 1.55;
    color: #374151;
    margin-bottom: 6px;
  }
}

/* Range colors (priority hero) */
.bg-alta,
.bg-muyAlto {
  background-color: #f4cdcd;
}
.bg-alto {
  background-color: #facca5;
}
.bg-media {
  background-color: #fff2cc;
}
.bg-destacado,
.bg-bajo {
  background-color: #d9ead3;
}
.bg-noRiesgo {
  background-color: #c8d9f7;
}
.bg-sinrango {
  background-color: #eceeec;
}

/* Collapse transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/components/menuInterpretacion.vue